import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap";
import { createApp } from "vue";
import axios from 'axios';

import App from './App.vue';
import router from './router';
import store from './store';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;  // the FastAPI backend

// Every data request carries the selected lidar (measurements_{lidar_id} on
// the backend). Routes that don't care simply ignore the query param.
axios.interceptors.request.use((config) => {
  const lidarId = store.getters.selectedLidarId;
  if (lidarId != null) {
    config.params = { ...(config.params || {}), lidar_id: lidarId };
  }
  return config;
});

// In local mode the backend doesn't enforce auth, so we don't install the
// 401-redirect interceptor (the corresponding /login route doesn't exist in
// local builds).
if (process.env.VUE_APP_MODE !== 'local') {
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        if (!['/login', '/register'].includes(window.location.pathname)) {
          store.dispatch("logOut");
          router.push("/login");
        }
      }
      return Promise.reject(error);
    }
  );
}
//store.replaceState({})
const app = createApp(App)
app.use(router);
app.use(store);
app.mount('#app')